<po-page-list #poPageListComponent
  p-title="Integração GTR - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DD3EMISSAO_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DD3EMISSAO_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DD3EMISSAO_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DD3EMISSAO_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="CD3OP"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CD3OP"
      p-label="Ordem de Produção:"
    ></po-input>
  </form>
</po-modal>

<po-modal #integrarGtrModal p-title="Integrar" [p-primary-action]="integrarActionModal">
  <form #formIntegrar="ngForm">
    <po-textarea
      class="po-md-12"
      name="CDESCRICAORETORNO"
      [(ngModel)]="itemIntegrar.CDESCRICAORETORNO"
      p-label="Descrição Retorno"
      [p-required]="true"
      [p-maxlength]="200"
    ></po-textarea>
  </form>
</po-modal>


<po-modal #logModal p-title="Log">
  <form>
    <po-textarea
      class="po-md-12"
      name="CLOG"
      [(ngModel)]="logVisualiza.CLOG"
      p-label="Log"
      [p-disabled]="true"
    ></po-textarea>
  </form>
</po-modal>
